import React from "react";
import { DragOverlay, useDraggable } from "@dnd-kit/core";
import { Icon, Portal } from "semantic-ui-react";
import "./index.scss";
import Avatar from "react-avatar";
import { ClippedContent } from "dyl-components/atoms/ClippedContent";
import { Link } from "react-router-dom";

function ItemCard({ item }) {
  return (
    <div className="Pipeline_Reports__Item">
      <div className="Pipeline_Reports__Item__Header">
        <Icon
          className="fa-solid fa-up-down-left-right  Pipeline_Reports__Item__Header__DragIcon"
        />
        <span className="Pipeline_Reports__Item__Header__IdText">ID: {item.pipeline_id}</span>
      </div>

      <div className="Pipeline_Reports__Item__Body">
        <div className="Pipeline_Reports__Item__Body__Information">
          <Avatar name={item.name} maxInitials={2} round size='3em' />
          <span className='Pipeline_Reports__Item__Body__Information-link'>
            <ClippedContent popupContent={<>
              Name: {item.name} <br />
              ID: {item.id}
            </>}>
              <Link
                to={`/contact/${item.id}`}
                onPointerDown={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation()
                }} target="_blank">{`${item.name}`}</Link>
            </ClippedContent>
            {`ID: ${item.id}`}
          </span>
        </div>
      </div>
    </div>
  );
}

export default function DraggableItem({ item }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging
  } = useDraggable({
    id: item.id
  });

  return (
    <>
      <div
        ref={setNodeRef}
        {...listeners}
        {...attributes}
        style={{
          opacity: isDragging ? 0.5 : 1,
        }}
      >
        <ItemCard item={item} />
      </div>
      <Portal open={isDragging}>

        <DragOverlay>
          <ItemCard item={item} />
        </DragOverlay>
      </Portal>
    </>
  );
}

export { ItemCard as Item };